import React from 'react';
import styled from 'styled-components';
/**
 * * 컬러칩
 */

interface IProps {
  color?: string;
}
const ColorChip = ({ color }: IProps) => {
  return <Chip color={color}></Chip>;
};

export default ColorChip;

const Chip = styled.div`
  width: 1rem;
  height: 1rem;
  background-color: ${(props) => props.color};
  margin-left: 0.3rem;
`;
